import { render, staticRenderFns } from "./sentence_practice.vue?vue&type=template&id=3a45c3b4&scoped=true"
import script from "./sentence_practice.vue?vue&type=script&lang=js"
export * from "./sentence_practice.vue?vue&type=script&lang=js"
import style0 from "./sentence_practice.vue?vue&type=style&index=0&id=3a45c3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a45c3b4",
  null
  
)

export default component.exports